"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderName = void 0;
const react_1 = __importDefault(require("react"));
const MapProviderCard_styles_1 = require("./MapProviderCard.styles");
const ProviderName = ({ name, id, viewProviderUrl, onViewProvider }) => {
    if (!(name === null || name === void 0 ? void 0 : name.trim())) {
        return null;
    }
    if (viewProviderUrl) {
        return (react_1.default.createElement(MapProviderCard_styles_1.ProviderNameLinkContainer, { href: viewProviderUrl, onClick: onViewProvider, "data-testid": `map-provider-content-link-${id}` }, name));
    }
    return (react_1.default.createElement(MapProviderCard_styles_1.ProviderNameContainer, { id: `map-provider-name-${id}`, "data-testid": `map-provider-name-${id}` }, name));
};
exports.ProviderName = ProviderName;
//# sourceMappingURL=ProviderName.js.map